<div #action
     class="hover:≈bg-primary-surface-hovered ≈cursor-pointer ≈p-2 md:≈p-3 ≈m-2 md:≈m-3 ≈rounded-3 sm:≈rounded 
         ≈select-none" 
    [ngClass]="{
        '≈bg-primary-surface-hovered': action['navigating']    
    }" 
    (click)="select($event)">

    <ng-content>

    </ng-content>

</div>